import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [isPulsing, setIsPulsing] = useState(true);
  useEffect(() => {
    // Show button after a short delay for a nice entrance
    const showTimer = setTimeout(() => setIsVisible(true), 1500);
    // Stop pulsing after 10 seconds
    const pulseTimer = setTimeout(() => setIsPulsing(false), 11500);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(pulseTimer);
    };
  }, []);
  return <div className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0'}`} data-id="element-310">
      {/* Pulse ring */}
      {isPulsing && <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30 pointer-events-none" data-id="element-311" />}

      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-3 whitespace-nowrap pointer-events-none" data-id="element-312">
        <div className={`bg-white text-gray-800 text-sm font-medium px-4 py-2 rounded-lg shadow-lg transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'}`} style={{
        transitionDelay: '2s'
      }} data-id="element-313">
          ¿Necesitas ayuda? 💬
          <div className="absolute top-full right-6 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-white" data-id="element-314" />
        </div>
      </div>

      {/* Button */}
      <a href="https://wa.me/19549804584?text=Hola%2C%20me%20interesa%20una%20consulta%20con%20MainPoint%20Multiservices" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center w-16 h-16 rounded-full bg-[#25D366] text-white shadow-lg hover:bg-[#20BD5A] hover:shadow-xl hover:scale-110 transition-all duration-300" aria-label="Chat on WhatsApp" data-id="element-315">
        <MessageCircle className="w-7 h-7 group-hover:scale-110 transition-transform" data-id="element-316" />
      </a>
    </div>;
}